module.exports = __webpack_public_path__ + "img/LP_MBG_GENESIS.f9ba0fa7.jpg";